import type { CSSProperties } from 'react'

export function opacityStyle(opacity: number): CSSProperties {
	return opacity >= 100 ? {} : { opacity: opacity / 100 }
}
